import { useState, useEffect } from 'react';
import axios from 'axios';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import { roleLabel, roleColor, situacaoEleitLabel, situacaoEleitColor } from '../utils/helpers';

export default function PerfilPage() {
  const { user, logout } = useAuth();
  const navigate         = useNavigate();
  const [profile,     setProfile]     = useState(null);
  const [network,     setNetwork]     = useState([]);
  const [inviteLink,  setInviteLink]  = useState('');
  const [loading,     setLoading]     = useState(true);

  useEffect(() => {
    Promise.all([axios.get('/api/auth/me'), axios.get('/api/users/my-network')])
      .then(([pR, nR]) => { setProfile(pR.data); setNetwork(nR.data); })
      .finally(() => setLoading(false));
  }, []);

  const getInviteLink = async () => {
    const r = await axios.get(`/api/users/${user.id}/invite-link`);
    setInviteLink(r.data.link);
  };

  if (loading) return (
    <div className="auth-container">
      <div className="loading-screen"><div className="spinner" /> Carregando...</div>
    </div>
  );

  return (
    <div style={{ minHeight: '100vh', background: 'var(--bg)', padding: '24px 16px' }}>
      <div style={{ maxWidth: 900, margin: '0 auto' }}>

        {/* Header */}
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start',
          marginBottom: 28, flexWrap: 'wrap', gap: 16 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
            <div style={{ width: 60, height: 60, borderRadius: '50%', background: 'var(--primary)',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontSize: 26, fontWeight: 700, color: '#fff', flexShrink: 0 }}>
              {profile?.nome?.[0] || '?'}
            </div>
            <div>
              <h1 style={{ fontSize: 22, fontWeight: 700, margin: 0, color: 'var(--primary)' }}>
                {profile?.nome || profile?.login}
              </h1>
              <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginTop: 8 }}>
                <span className="pill" style={{ background: roleColor(profile?.role) + '22', color: roleColor(profile?.role) }}>
                  {roleLabel(profile?.role)}
                </span>
                <span className="pill" style={{ background: situacaoEleitColor(profile?.situacao_eleitoral) + '22', color: situacaoEleitColor(profile?.situacao_eleitoral) }}>
                  {situacaoEleitLabel(profile?.situacao_eleitoral)}
                </span>
                <span className="pill" style={{ background: profile?.situacao_cadastro === 'ATIVO' ? '#05785522' : '#c2780322', color: profile?.situacao_cadastro === 'ATIVO' ? '#057a55' : '#c27803' }}>
                  Cadastro: {profile?.situacao_cadastro === 'ATIVO' ? '✅ Ativo' : '⏳ Pendente'}
                </span>
              </div>
            </div>
          </div>
          <button onClick={logout} className="btn btn-outline" style={{ borderColor: 'var(--danger)', color: 'var(--danger)' }}>
            Sair
          </button>
        </div>

        {/* Grid de cards */}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: 20, marginBottom: 20 }}>

          {/* Dados Pessoais */}
          <div className="card">
            <h3 className="card-title">📋 Dados Pessoais</h3>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
              {[
                ['Login',            profile?.login],
                ['CPF',              profile?.cpf],
                ['Nascimento',       profile?.data_nascimento ? new Date(profile.data_nascimento).toLocaleDateString('pt-BR') : '-'],
                ['Nome da Mãe',      profile?.nome_mae],
                ['Município',        profile?.municipio],
                ['Telefone/WhatsApp',profile?.telefone],
                ['Tipo',             profile?.tipo],
                ['Cadastrado em',    profile?.created_at ? new Date(profile.created_at).toLocaleDateString('pt-BR') : '-'],
              ].map(([label, value]) => (
                <div key={label}>
                  <div style={{ color: '#555', fontSize: 11, fontWeight: 700, letterSpacing: 1 }}>{label}</div>
                  <div style={{ color: '#000', fontSize: 13, fontWeight: 500, marginTop: 2 }}>{value || '-'}</div>
                </div>
              ))}
            </div>
          </div>

          {/* Link de convite */}
          <div className="card">
            <h3 className="card-title">🔗 Link de Convite</h3>
            <p style={{ color: '#555', fontSize: 13, marginBottom: 16, lineHeight: 1.6 }}>
              Compartilhe este link para convidar pessoas para sua rede.
            </p>
            <button onClick={getInviteLink} className="btn" style={{ marginBottom: 14, width: '100%' }}>
              Gerar Meu Link
            </button>
            {inviteLink && (
              <div className="invite-box">
                <input readOnly value={inviteLink} className="invite-input"
                  onClick={e => { e.target.select(); navigator.clipboard.writeText(inviteLink); }} />
                <button onClick={() => navigator.clipboard.writeText(inviteLink)} className="copy-btn">📋 Copiar</button>
              </div>
            )}
            <button onClick={() => navigate('/')} className="btn btn-outline" style={{ marginTop: 12, width: '100%', fontSize: 12 }}>
              ← Voltar ao Login
            </button>
          </div>
        </div>

        {/* Rede */}
        {network.length > 0 && (
          <div className="card">
            <h3 className="card-title">👥 Minha Rede ({network.length} pessoas)</h3>
            <div className="table-wrap">
              <table className="r-table">
                <thead>
                  <tr>
                    {['NOME','MUNICÍPIO','PERFIL','SIT. ELEITORAL','CADASTRO'].map(h => <th key={h}>{h}</th>)}
                  </tr>
                </thead>
                <tbody>
                  {network.map(u => (
                    <tr key={u.id}>
                      <td><div style={{ fontWeight: 600 }}>{u.nome || '-'}</div><div style={{ fontSize: 11, color: '#555' }}>{u.login}</div></td>
                      <td>{u.municipio || '-'}</td>
                      <td><span className="pill" style={{ background: roleColor(u.role) + '22', color: roleColor(u.role) }}>{roleLabel(u.role)}</span></td>
                      <td><span className="pill" style={{ background: situacaoEleitColor(u.situacao_eleitoral) + '22', color: situacaoEleitColor(u.situacao_eleitoral) }}>{situacaoEleitLabel(u.situacao_eleitoral)}</span></td>
                      <td><span className="pill" style={{ background: u.situacao_cadastro === 'ATIVO' ? '#05785522' : '#c2780322', color: u.situacao_cadastro === 'ATIVO' ? '#057a55' : '#c27803' }}>{u.situacao_cadastro === 'ATIVO' ? 'Ativo' : 'Pendente'}</span></td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
